<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2022-2024, Vector Software BV                             **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Vector Software BV. Unauthorized copying or disclosure of this file,    **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
*****************************************************************************
-->

<template>
    <div id="tasklist" v-if="customerId" :class="tasklistStyle">
        <v-expand-transition v-if="$auth.subscription == 'VCT1' && !hideTasks">
            <v-card max-height="90vh">
                <v-container>
                    <v-row>
                        <v-col class="px-2 py-1 d-flex align-center" cols="1">
                            <v-icon @click="menuIconClick()">mdi-menu</v-icon>
                        </v-col>
                        <v-col class="py-0 d-flex align-center">
                            <v-select dense v-model="select" :placeholder="language.t('Vector.Tasklist.selectDevice')"
                                :items="devices" item-text="designator" item-value="accountId">
                            </v-select>
                        </v-col>
                        <v-col cols="1" class="px-2 py-1 d-flex justify-end">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="addTask()">
                                        <v-icon color="green darken-2" v-bind="attrs" v-on="on">
                                            mdi-plus-circle
                                        </v-icon>
                                    </v-btn>

                                </template>
                                <span>{{ language.t("Tasklist.createTask") }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-divider></v-divider>
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="d-flex pa-0 align-center justify-center">
                            <v-checkbox v-model="newFilter" @change="getTasks()"
                                :label="language.t('Tasklist.taskStatusNew')"></v-checkbox>
                        </v-col>
                        <v-col cols="3" class="d-flex pa-0 align-center justify-center">
                            <v-checkbox v-model="removedFilter" @change="getTasks()"
                                :label="language.t('Tasklist.taskStatusRemoved') + '/' + language.t('Tasklist.taskStatusCompleted')"></v-checkbox>
                        </v-col>
                        <!-- <v-col> <v-btn v-if="account != 0" v-on:click="calender()"> {{ language.t("Vector.Planning.planning") }}</v-btn></v-col> -->
                    </v-row>
                    <v-row v-if="selectedTaskName != ''">
                        <v-col class="text-body-1">
                            {{ language.t("Vector.SelectedTask") }}: {{ selectedTaskName }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-0">
                            <v-subheader> {{ language.t("Tasklist.tasklistHeaderTasks") }} </v-subheader>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-0">
                            <v-list :style="selectedTaskName != '' ? 'max-height:  calc(40vh - 48px)' : 'max-height: 40vh'"
                                class="overflow-y-auto">
                                <v-list-item v-for="task in tasks" v-bind:data="task" v-bind:key="task.taskId">
                                    <v-list-item-avatar @click="openTask(task)">
                                        <v-icon
                                            :color="task.status == '__TASKSTATUSTYPE_NEW' ? 'success' : task.status == '__TASKSTATUSTYPE_DONE' ? 'blue' : 'error'">mdi-map</v-icon>
                                    </v-list-item-avatar>
                                    <v-tooltip bottom open-delay="200">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item-content v-bind="attrs" v-on="on" @click="openTask(task)">
                                                <v-list-item-title>{{ task.name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ task.edited }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>

                                        <span>{{ task.name }}</span>
                                    </v-tooltip>
                                    <v-hover v-slot="{ hover }">
                                        <v-list-item-action>
                                            <v-container class="pa-0" v-if="task.status === '__TASKSTATUSTYPE_NEW'">
                                                <v-row>
                                                    <v-col class="pa-0">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" icon small @click="changeStatus(task, '__TASKSTATUSTYPE_DONE')
                                                                    ">
                                                                    <v-icon
                                                                        :color="hover ? 'green' : 'grey lighten-3'">mdi-check</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ language.t("Tasklist.completeTask") }}</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col class="pa-0">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" icon small
                                                                    @click="changeStatus(task, '__TASKSTATUSTYPE_REMOVED')">
                                                                    <v-icon
                                                                        :color="hover ? 'red' : 'grey lighten-3'">mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ language.t("Tasklist.RemoveTask") }}</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                            <v-container class="pa-0"
                                                v-else-if="task.status === '__TASKSTATUSTYPE_DONE' || task.status === '__TASKSTATUSTYPE_REMOVED'">
                                                <v-row>
                                                    <v-col class="pa-0">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" icon small
                                                                    @click="changeStatus(task, '__TASKSTATUSTYPE_NEW')">
                                                                    <v-icon
                                                                        :color="hover ? 'green' : 'grey lighten-3'">mdi-refresh
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ language.t("Tasklist.restoreTask") }}</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-list-item-action>
                                    </v-hover>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions class="card-actions">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="hideTaskList()"><v-icon>mdi-chevron-up</v-icon></v-btn>

                </v-card-actions>
            </v-card>
        </v-expand-transition>
        <v-expand-transition v-if="$auth.subscription == 'VCT1' && hideTasks">
            <v-card>
                <v-container fluid>
                    <v-row>
                        <v-col class="px-2 py-1 d-flex align-center" cols="1">
                            <v-icon @click="menuIconClick()">mdi-menu</v-icon>
                        </v-col>
                        <v-col class="py-0 d-flex align-center" cols="9">
                            <v-select dense v-model="select" :placeholder="language.t('Vector.Tasklist.selectDevice')"
                                :items="devices" item-text="designator" item-value="accountId">
                            </v-select>
                        </v-col>
                        <v-col class="px-2 py-1 d-flex justify-end">
                            <v-btn icon @click="hideTaskList()"><v-icon @click="hideTaskList()">mdi-chevron-down</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-expand-transition>
    </div>
</template>
  
<script>

export default {
    components: {
    },
    data() {
        return {
            autoUpdate: true,
            tasks: null,
            allTasks: null,
            select: { accountId: 0, designator: "selecteer device" },
            devices: [],
            newFilter: true,
            removedFilter: false,
            hideTasks: false,
            selectedTaskName: ''
        };
    },
    mounted: function () {
        this.getDevices();
        this.getTasks();
    },
    props: {
        map: {
            required: true,
        },
    },
    computed: {
        customerId() {
            return this.$auth.customerId;
        },
        tasklistStyle: function () {
            return {
                floating: !this.$vuetify.breakpoint.xsOnly,
                inline: this.$vuetify.breakpoint.xsOnly,
            };
        },
        account() {
            return this.$selectedVector.accountId;
        },
        task() {
            return this.$selectedTask.taskId;
        },
        projectionList() {
            return this.$projections.all;
        }
    },
    watch: {
        customerId(val) {
            if (Number.isInteger(val)) {
                this.getDevices();
                this.tasks = null
                this.allTasks = null;
                this.getTasks();
            }
        },
        task() {
            if (Number(this.task) == 0 && this.selectedTaskName != '') {
                this.selectedTaskName = ''
            } else {
                if (this.tasks != null) {
                    this.selectedTaskName = this.tasks.find(({ taskId }) => taskId === Number(this.task)).name;
                } else {
                    this.$axios
                        .get(route("api.task", Number(this.task)))
                        .then((res) => {
                            this.selectedTaskName = res.data.name
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                }
            }

        },
        select() {
            this.$selectedVector.accountId = this.select;

            this.zoomOnDevice();
        },
        projectionList() {
            if (this.projectionList.length > 1) {
                this.getTasks();
            }
        },
        'map.devicesLoaded'(val) {
            if (val) {
                if (this.devices.length < 2) {
                    this.select = this.devices[0].accountId;
                }
            }
        }
    },
    methods: {
        getDevices() {
            this.$axios.get(route("api.devices")).then((res) => {
                this.devices = res.data;
                this.devices.forEach(device => {
                    device.designator = device.designator ? device.designator : device.serialNumber;
                });

                if (this.devices.length < 2) {
                    this.select = this.devices[0].accountId;
                }
            });
        },
        menuIconClick() {
            this.$emit("menuListClick");
        },
        addTask() {
            this.$emit("menuSelected", "taskCreate");
        },
        async getTasks() {
            if (this.allTasks == null) {
                this.requestCancelToken = this.$axios.CancelToken.source();
                var res = await this.$axios.get(route("api.tasks"), { cancelToken: this.requestCancelToken.token, })
                this.allTasks = res.data;
            }

            var tempTasks = this.allTasks.reduce((tasks, task) => {
                if (this.newFilter && task.status == "__TASKSTATUSTYPE_NEW") {
                    tasks.push(task);
                } else if (this.removedFilter && (task.status == "__TASKSTATUSTYPE_REMOVED" || task.status == "__TASKSTATUSTYPE_DONE")) {
                    tasks.push(task);
                }
                return tasks;
            }, [])

            tempTasks.sort(function (x, y) {
                return new Date(y.edited) - new Date(x.edited);
            });
            this.tasks = tempTasks;
        },
        openTask(task) {
            this.$emit("openTask", task);
        },
        zoomOnDevice() {
            this.$nexttick(() => {
                var ext = this.map.mapDevices.getExtendForFeature(this.$selectedVector.accountId);
                this.map.map.fitExtend(ext);
            })
        },
        hideTaskList() {
            this.hideTasks = !this.hideTasks;
        },
        calender() {
            this.$emit("openCalendar");
        },
        changeStatus(task, status) {
            if (task) {
                this.$axios.get(route("api.tasks.status", [task.taskId, status])).then((res) => {
                    var taskIndex = this.allTasks.findIndex((t) => {
                        return t.taskId == task.taskId;
                    });
                    this.allTasks[taskIndex].status = status;

                    var tempTasks = this.allTasks.reduce((tasks, task) => {
                        if (this.newFilter && task.status == "__TASKSTATUSTYPE_NEW") {
                            tasks.push(task);
                        } else if (this.removedFilter && (task.status == "__TASKSTATUSTYPE_REMOVED" || task.status == "__TASKSTATUSTYPE_DONE")) {
                            tasks.push(task);
                        }
                        return tasks;
                    }, [])

                    tempTasks.sort(function (x, y) {
                        return new Date(y.edited) - new Date(x.edited);
                    });
                    this.tasks = tempTasks;
                });
            }
        }
    },
};
</script>
  
<style scoped>
#tasklist {
    z-index: 75;
    /*margin-left: 5px;*/
}

#tasklist form {
    display: flex;
    flex: 1 1 auto;
    margin: -12px;
}

#controlPanel {
    z-index: 75;
    margin-left: 5px;
}

.floating {
    position: absolute;
    top: 23px;
    left: 23px;
    width: 400px;
}

.inline {
    position: absolute;
    width: calc(100vw - 18px - 18px);
    top: 18px;
    left: 18px;
}
</style>
  
<style>
/* Manual fix for this bug: https://github.com/vuetifyjs/vuetify/issues/13133 */
/* v-autocomplete using item slot with v-list-item-title and v-list-item-subtitle is rendered too wide */
/* .v-autocomplete__content,
.v-list-item-bugfix {
    width: 400px !important;
    max-height: 80% !important;
    /* this is just to increase the height 
} */

#tasklist .v-input__slot {
    margin-bottom: 0px;
}

#tasklist .v-text-field__details {
    min-height: unset;
    height: 0px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px;
}

.v-chip.v-chip--no-color.theme--light.v-size--default.ERROR {
    background: red;
}

.v-chip.v-chip--no-color.theme--light.v-size--default.IDLE .v-chip.v-chip--no-color.theme--light.v-size--default.INIT {
    background: lightgray;
}

.v-chip.v-chip--no-color.theme--light.v-size--default.WORKING {
    background: green;
}

.v-chip.v-chip--no-color.theme--light.v-size--default.CHARGING {
    background: lightskyblue;
}

.v-icon.batteryEmpty {
    color: red;
}

.v-icon.batteryFull {
    color: rgba(0, 0, 0, .54);
}
</style>